module.exports = __webpack_public_path__ + "img/screen_5.c6260225.svg";